import { AlertTriangle, Home, RotateCcw } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/cn';

export function RouteErrorPage() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Die Ansicht konnte nicht geladen werden.';

  return (
    <main className="grid min-h-dvh place-items-center bg-canvas p-6 text-ink">
      <section className="w-full max-w-md rounded-2xl border border-danger/25 bg-surface p-6 shadow-soft">
        <div className="grid size-11 place-items-center rounded-xl bg-danger/10 text-danger">
          <AlertTriangle aria-hidden="true" className="size-5" />
        </div>
        <h1 className="mt-4 font-display text-2xl font-bold">Diese Ansicht ist gestolpert</h1>
        <p className="mt-2 text-sm leading-relaxed text-muted">
          Deine lokalen Daten bleiben erhalten. Du kannst die Ansicht neu laden oder sicher zur
          Heute-Seite zurückkehren.
        </p>
        <p className="mt-3 rounded-xl bg-elevated p-3 text-xs text-muted">{detail}</p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Button className="flex-1" onClick={() => window.location.reload()}>
            <RotateCcw aria-hidden="true" className="size-4" /> Neu laden
          </Button>
          <Link className={cn(buttonVariants({ variant: 'outline' }), 'flex-1')} to="/today">
            <Home aria-hidden="true" className="size-4" /> Heute
          </Link>
        </div>
      </section>
    </main>
  );
}
